import { push } from 'connected-react-router';

export const changeTab = (section, tabId) => async (dispatch) => {
    dispatch(push(`/${section}/${tabId}`));
};


// WEBPACK FOOTER //
// ./src/actions/siteInformations.js